import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import '../styles/in-game.css';

export class UnwrappedInGameButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      joinGame: false,
      player: this.props.authedUser,
    }
  }

  joinRoom = () => {
    this.setState({
      joinGame: true
    })
  }

  render() {
    const { inGame, room } = this.props;
    return (
      <div className="in-game-notifier">
        {inGame &&
          <button onClick={() => this.joinRoom()}>YOU ARE IN A GAME. CLICK TO JOIN.</button>
        }
        {this.state.joinGame &&
          <Redirect to={{
            pathname: `/${room}`,
            state: {
              roomId: room,
              faction: room.faction,
              // time: this.state.timePick
            }
          }} />
        }
      </div>
    )
  }
}

function mapStateToProps ({ authedUser, inGame, room }) {
  return {
    authedUser,
    inGame,
    room
  }
}

export const InGameButton = connect(mapStateToProps)(UnwrappedInGameButton);